import { render } from "./SidebarItemList.vue?vue&type=template&id=147fd04e&scoped=true"
import script from "./SidebarItemList.vue?vue&type=script&lang=js"
export * from "./SidebarItemList.vue?vue&type=script&lang=js"

import "./SidebarItemList.vue?vue&type=style&index=0&id=147fd04e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147fd04e"]])

export default __exports__